import { useNavigate } from "react-router-dom";
import { ServiceRequestsIcon } from "../../../../../assets/icons";
import EmptyState from "../../../../../common/components/xepp/empty-state/EmptyState";
import UtilityPageLayout from "../../../component/layout/UtilityPageLayout";
import { useState } from "react";
import FieldTypeModal from "../components/FieldModal/FieldTypeModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../stores/store";
import styles from "./CustomFormPage.module.scss";
import Button from "../../../../../common/components/xepp/button/Button";
import ServiceTypeFormInformation from "../components/FormInfo/ServiceTypeFormInformation";
import { Attribute } from "../../../../../model/service-request/attribute";
import NewSectionModal from "../components/NewSectionModal/NewSectionModal";
import { toast } from "react-toastify";

const CustomFormPage = () => {
	const currentState = useSelector((state: RootState) => state.serviceType);
	const navigator = useNavigate();

	const [showNewSectionModal, setShowNewSectionModal] = useState(false);

	const onContinueClick = () => {
		const hasInvalidSection = currentState.sectionDefinitions.some(section => section.attributeDefinitions.length < 1);

		if (hasInvalidSection) {
			toast.error("Each section must contain at least one attribute");
			return;
		}
		navigator("payment-option");
	};

	const onCancelClick = () => {
		navigator(-1);
	};

	return (
		<UtilityPageLayout title="Custom Form">
			{showNewSectionModal && <NewSectionModal onModalClose={() => setShowNewSectionModal(false)} />}

			<div>
				<div className={styles.contentContainer}>
					<div className={styles.content}>
						<div className={styles.headerWrapper}>
							<span className={styles.formName}>{currentState.name}</span>
							<div
								className={styles.addNewSectionContainer}
								onClick={() => {
									setShowNewSectionModal(true);
								}}
							>
								<span>Add New Section</span>
								<div className={styles.addBtn}>+</div>
							</div>
						</div>
						<div className={styles.formInfoSection}>
							<ServiceTypeFormInformation />
						</div>
						<div className={styles.footerWrapper}>
							<Button text={"Cancel Setup"} onClick={onCancelClick} variant={"outline"} />
							<Button text={"Continue"} onClick={onContinueClick} variant={"secondary"} />
						</div>
					</div>
				</div>
			</div>
		</UtilityPageLayout>
	);
};

export default CustomFormPage;
